<template>
  <div class="border border-1 p-2 pt-3">
    <div class="d-flex flex-row" style="gap: 20px;">
      <div>
        <label class="radio radio-gold ml-3">
          <input 
            type="radio" 
            :name="'firstActiveTierCondition'" 
            v-model="data.meta.conditions[childIndexing].value" 
            :value="condition.value" 
          />
          <span class="checkmark"></span>
        </label>
      </div>

      <div v-if="index === 0">
        <CheckboxComponent 
          :options="checkboxTiers" 
          v-model="data.meta.conditions[childIndexing].tiers" 
          :disabled="data.meta.conditions[childIndexing].value !== 'select_tier'" 
        />
      </div>

      <div v-if="index === 1">
        <RangeComponent 
          :ageFrom.sync="data.meta.conditions[childIndexing].tier_from" 
          :ageTo.sync="data.meta.conditions[childIndexing].tier_to" 
          firstText="From" 
          secondText="To" 
          :disabled="data.meta.conditions[childIndexing].value !== 'point_range'" 
          :requiredInput="data.meta.conditions[childIndexing].value == 'point_range'"
        />
      </div>

      <div v-if="index === 2">
        <RequirementInputLabel 
          class="mb-1" 
          type="number" 
          firstLabel="About to Expire in" 
          secondLabel="days" 
          :value.sync="data.meta.conditions[childIndexing].days" 
          :disabled="data.meta.conditions[childIndexing].value !== 'expiry_in'" 
          :inputRequired="data.meta.conditions[childIndexing].value == 'expiry_in'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RequirementInputLabel from './RequirementInputLabel.vue';
import RangeComponent from './RangeComponent.vue';
import CheckboxComponent from './CheckboxComponent.vue';

export default {
  components: {RequirementInputLabel, RangeComponent, CheckboxComponent},
  props: {
    condition: { type: Object, required: true },
    index: { type: Number, required: true },
    data: { type: Object, required: true },
    checkboxTiers: { type: Array, required: true },
    childIndexing: {type: Number, required: true} 
  },
};
</script>
